import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import {
  setProgressStep,
  setGroup,
  setSubscriptionPackage,
  setSubscriptionRenewable,
  setOpenStackConfigs,
  setAdminUiConfigs,
  setCustomerUiConfigs,
  setBillingConfigs,
  setBillingConfigPermissions,
} from '../../../store/reducers/subscriptionAddSlice'
import defaultTexts from '../../../texts/texts'
import CustomDialog from '../../_common/CustomDialog'

const NoSubscriptionWrapper = (props) => {
  const { subscriptionGroupsData, groupName } = props
  const theme = useTheme()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const user_role = useSelector(state => state.profile.user_role)
  const editPermission = user_role === 'superadmin' || user_role === 'owner' || user_role === 'admin'

  const [subscriptionGroup, setSubscriptionGroup] = useState(null)
  const [buyNewSubscriptionDialogOpen, setBuyNewSubscriptionDialogOpen] = useState(false)

  const pageLabelStyle = {
    color: theme.palette.vodka,
    fontSize: '18px',
    fontWeight: '500',
    padding: '0px 0px 20px 20px',
  }

  const wrapperStyle = {
    background: theme.palette.aliceBlue,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    padding: '100px 20px',
    borderRadius: '20px',
  }

  const noActiveSubscriptionsTextStyle = {
    fontSize: '28px',
    textAlign: 'center',
  }

  const subscribeButtonStyle = {
    fontWeight: '400',
    color: 'white',
    background: theme.palette.violetsAreBlue,
    fontSize: '20px',
    height: '44px',
    borderRadius: '22px',
    padding: '0px 40px',
    marginTop: '40px',
    textTransform: 'capitalize',

    '&:hover': {
      background: alpha(theme.palette.violetsAreBlue, 0.8),
    },

    '&:disabled': {
      background: theme.palette.grayX11,
      color: 'white',
    },
  }

  const confirmButtonStyle = {
    fontWeight: '500',
    color: 'white',
    background: theme.palette.greenSheen,
    fontSize: '18px',
    height: '40px',
    borderRadius: '20px',
    padding: '0px 30px',
    textTransform: 'capitalize',
    marginTop: '20px',

    '&:hover': {
      background: alpha(theme.palette.greenSheen, 0.8),
    },
  }

  const handleNuyNewSubscriptionDialogClose = () => {
    setBuyNewSubscriptionDialogOpen(false)
  }

  const handleClickSubscribe = () => {
    if (subscriptionGroup) {
      setBuyNewSubscriptionDialogOpen(true)
    }    
  }

  const buyNewSubscription = () => {
    dispatch(setProgressStep({ progress_step: 2 }))
    dispatch(setGroup({ group: subscriptionGroup.group_name }))
    
    dispatch(setSubscriptionPackage({
      subscription_package: {
        id: null,
        name: null,
        services: [],
      }
    }))

    dispatch(setSubscriptionRenewable({ subscription_renewable: true }))
    dispatch(setOpenStackConfigs({ openstack_configs: [] }))
    dispatch(setAdminUiConfigs({ admin_ui_configs: null }))
    dispatch(setCustomerUiConfigs({ customer_ui_configs: null }))
    dispatch(setBillingConfigs({ billing_configs: null }))
    dispatch(setBillingConfigPermissions({ billing_permissions: null }))
    
    navigate('/add-new')
  }

  useEffect(() => {
    setSubscriptionGroup(subscriptionGroupsData.find(item => item.group_name === groupName))
  }, [subscriptionGroupsData, groupName])
  
  return (
    <>
      <Box sx={{ padding: '40px 20px' }}>
        <Box sx={pageLabelStyle}>
          { subscriptionGroup && subscriptionGroup.title && subscriptionGroup.title.value ? subscriptionGroup.title.value : '' }
        </Box>
      
        <Box sx={wrapperStyle}>
          <Box sx={noActiveSubscriptionsTextStyle}>{defaultTexts.noActiveSubscriptions}</Box>
          {
            editPermission &&
            <Stack
              direction='row'
              justifyContent='center'
            >
              <Button
                variant='text'
                disableRipple
                disableElevation
                sx={subscribeButtonStyle}
                onClick={handleClickSubscribe}
              >
                {defaultTexts.subscribe}
              </Button>
            </Stack>
          }          
        </Box>
      </Box>

      <CustomDialog
        open={buyNewSubscriptionDialogOpen}
        onClose={handleNuyNewSubscriptionDialogClose}
        dialogTitle={{
          title: defaultTexts.buyNewSubscription,
          sx: {
            color: theme.palette.violetsAreBlue,
            fontSize: '22px',
            fontWeight: '500',
          }
        }}
        dialogBody={{
          text: defaultTexts.buyNewSubscriptionText,
          sx: { fontSize: '18px', color: 'black' }
        }}
        actionButtons={[{
          title: defaultTexts.confirm, 
          onClick: buyNewSubscription,
          sx: confirmButtonStyle,
        }]}
        closeIconColor={theme.palette.violetsAreBlue}
      />
    </>    
  )
}

export default NoSubscriptionWrapper